import { render, staticRenderFns } from "./Interactive.vue?vue&type=template&id=45a220dc&scoped=true&"
import script from "./Interactive.vue?vue&type=script&lang=js&"
export * from "./Interactive.vue?vue&type=script&lang=js&"
import style0 from "./Interactive.vue?vue&type=style&index=0&id=45a220dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a220dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a220dc')) {
      api.createRecord('45a220dc', component.options)
    } else {
      api.reload('45a220dc', component.options)
    }
    module.hot.accept("./Interactive.vue?vue&type=template&id=45a220dc&scoped=true&", function () {
      api.rerender('45a220dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/mindAr/components/Interactive.vue"
export default component.exports